// components/RequireVip.jsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Lock as LockIcon } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import VipTeaser from './VipTeaser';
import {
  getRequirementTeaserMessage,
  hasRequirementAccess,
  normalizeRequirement,
} from '../utils/accessControl';

export default function RequireVip({
  children,
  variant = 'teaser-full',
  message = 'Dostęp tylko dla VIP',
  blurAmount = '4px',
  sx = {},
  lockedTo,
  requirement = 'vip',
}) {
  const { user, loading, hasRole, vipModeEnabled } = useAuth();

  if (loading) return <div>Ładowanie...</div>;

  const normalizedRequirement = normalizeRequirement(requirement);
  const isAllowed = hasRequirementAccess({ requirement, user, hasRole, vipModeEnabled });

  if (isAllowed) return children;

  const teaserMessage = getRequirementTeaserMessage(requirement, message);
  const linkTo = normalizedRequirement === 'login' ? '/login' : '/vip';
  const buttonText = normalizedRequirement === 'login' ? 'Zaloguj się' : 'Kup dostęp';

  switch (variant) {
    case 'lock-icon':
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <LockIcon fontSize="large" color="disabled" />
          <Typography variant="body2" color="text.secondary" mt={1}>
            {teaserMessage}
          </Typography>
        </Box>
      );

    case 'blur':
      return (
        <Box
          sx={{
            position: 'relative',
            filter: `blur(${blurAmount})`,
            pointerEvents: 'none',
          }}
        >
          {children}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              borderRadius: 1,
            }}
          />
        </Box>
      );

    case 'simple-text':
      return lockedTo ? (
        <Typography component={RouterLink} to={lockedTo} sx={{ textDecoration: 'none', ...sx }}>
          {teaserMessage}
        </Typography>
      ) : (
        <Typography sx={sx}>{teaserMessage}</Typography>
      );

    case 'short-text':
      return lockedTo ? (
        <Typography component={RouterLink} to={lockedTo} sx={{ textDecoration: 'none', ...sx }}>
          (VIP)
        </Typography>
      ) : (
        <Typography sx={sx}>(VIP)</Typography>
      );

    case 'nothing':
      return <Typography />;

    case 'teaser-full':
      return (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="h6" gutterBottom>
            {teaserMessage}
          </Typography>
          <Button variant="contained" component={RouterLink} to={linkTo} sx={{ mt: 2 }}>
            {buttonText}
          </Button>
        </Box>
      );

    case 'vip-teaser':
      return <VipTeaser />;

    default:
      return (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="h6" gutterBottom>
            {teaserMessage}
          </Typography>
          <Button variant="contained" component={RouterLink} to={linkTo} sx={{ mt: 2 }}>
            {buttonText}
          </Button>
        </Box>
      );
  }
}
